import { jsxs as c, jsx as o } from "react/jsx-runtime";
import l from "../heading-and-content/HeadingAndContent.js";
import _ from "../../components/heading/Heading.js";
import m from "../../components/accordion/Accordion.js";
import u from "../../components/banner/Banner.js";
import '../../assets/Faq.css';const x = "_header_1ueyx_9", g = "_content_1ueyx_15", p = "_section_1ueyx_18", q = "_faqs_1ueyx_26", e = {
  header: x,
  content: g,
  section: p,
  faqs: q
}, b = ({ titleVariant: f = "h2", articles: n, sections: s, children: r, emptyState: t, ...h }) => /* @__PURE__ */ c(
  l,
  {
    titleVariant: f,
    serifTitle: !0,
    classnames: { header: e.header, content: e.content },
    ...h,
    children: [
      !!r && r,
      s ? s.map(
        ({ title: d, slug: i, items: a }) => a.length ? /* @__PURE__ */ c("section", { className: e.section, children: [
          s.length > 1 && /* @__PURE__ */ o(_, { as: "h1", variant: "h3", serif: !0, className: "mb-400", children: d }),
          /* @__PURE__ */ o(m, { className: e.faqs, items: a })
        ] }, i) : null
      ) : n && (n == null ? void 0 : n.length) > 0 ? /* @__PURE__ */ o(m, { className: e.faqs, items: n }) : typeof t == "string" ? /* @__PURE__ */ o(u, { children: t }) : t || null
    ]
  }
);
export {
  b as default
};
